export const agentSubscriptions = {
  breakTime: {
    counterTypeId: 'e1604428-6266-4c5a-86f0-ecfd4b9a7e8e',
    counterTypeName: 'Agent Break Time'
  },
  busyTime: {
    counterTypeId: '02c82ca3-092e-411b-a519-c9eb53bcd724',
    counterTypeName: 'Agent Total Busy Time'
  },
  backofficeTime: {
    counterTypeId: 'be3adb18-15f1-43cb-ba6e-ab2cfee1603c',
    counterTypeName: 'Backoffice'
  },
  readyTime: {
    counterTypeId: '6807e845-cdb0-432d-83b4-e7892b88207f',
    counterTypeName: 'Agent Total Ready Time'
  },
  outgoingTime: {
    counterTypeId: '5a7c3c47-6cf3-4c7a-a29d-c1b1aa979cb3',
    counterTypeName: 'Agent Total Handling Outgoing Time'
  },
  loginTime: {
    counterTypeId: 'cba49dd5-0628-4777-bb2d-c6335a653092',
    counterTypeName: 'Agent Last Login Time'
  }
};
